import commandUtils from 'utils/commandUtils';
import selectionUtils from 'utils/selectionUtils';

function FormatBlockCommand(classNamePrefix) {
    this.classNamePrefix = classNamePrefix;
}

function findClassThatStartsWith(classList, prefix) {
    var index;
    for (index = 0; index < classList.length; index++) {
        if (classList[index].indexOf(prefix) === 0) {
            return classList[index];
        }
    }

    return null;
}

FormatBlockCommand.prototype = {
    contextSensitive: true,
    exec: function (editor, params) {
        var thisCommand = editor.getCommand('formatBlock');
        var firstBlockElement, lastBlockElement;

        if (thisCommand.canUndo) {
            editor.undoManager.save();
        }

        editor.undoManager.lock(true);

        selectionUtils.enlargeSelectionToBlock(editor);
        if (!params.shouldRetainThemesAndStyles) {
            commandUtils.execNestedCommand(editor.getCommand('resetThemeAndStyles'), thisCommand);
            commandUtils.execNestedCommand(editor.getCommand('lineHeight'), thisCommand, CKEDITOR.TRISTATE_OFF);
        }

        selectionUtils.getSelectedBlocks(editor, true).forEach(blockElement => {
            const newBlockValues = this.getBlockValues(blockElement.$.classList, params);
            blockElement.renameNode(newBlockValues.tag);

            if (newBlockValues.class) {
                const newClassStyle = new CKEDITOR.style({
                    attributes: {
                        class: newBlockValues.class
                    }
                });

                editor.forceNextSelectionCheck();
                newClassStyle.applyToObject(blockElement, editor);
            }

            // we keep references to the first and last blocks to restore selection, which is lost after renaming nodes
            firstBlockElement = firstBlockElement || blockElement;
            lastBlockElement = blockElement;
        });

        selectionUtils.setSelectionBetweenElements(editor, firstBlockElement, lastBlockElement);
        selectionUtils.getSelectedLists(editor).forEach(element => {
            const newBlockValues = this.getBlockValues(element.$.classList, params);
            this.applyOnElement(newBlockValues, element);
        });

        this.setState({
            tag: firstBlockElement.getName(),
            class: firstBlockElement.getAttribute('class')
        });

        editor.undoManager.unlock();
    },
    refresh: function (editor, elementPath) {
        var block = elementPath.block || elementPath.blockLimit;
        var classState = block.getAttribute('class');
        if (this.classNamePrefix) {
            classState = findClassThatStartsWith(block.$.classList, this.classNamePrefix);
        }

        this.setState({
            tag: block.getName(),
            class: classState
        });
    },
    applyOnElement: function (value, element) {
        if (value.class) {
            const classes = (element.getAttribute('class') || '')
                .split(' ')
                .filter(str => /^font_\d+$/.test(str));
            classes.forEach(_class => element.removeClass(_class));
            element.addClass(value.class);
        }
    },
    getBlockValues: function (classList, params) {
        if (params.getNewBlockValue) {
            let themeName = classList.value;

            if (this.classNamePrefix) {
                themeName = findClassThatStartsWith(classList, this.classNamePrefix);
            }

            return params.getNewBlockValue(themeName);
        } else if (!params.tag) {
            throw new Error('You must specify a tag or a getNewBlockValue method');
        }

        return params;
    }
};

export default FormatBlockCommand;
